// Components
import { RootState } from '../index';

const getCatalogNextTraining = (state: RootState) => state.catalogDataSlice.next_training;

const getCatalogItems = (state: RootState) => state.catalogDataSlice.items;

const getCatalogItemsCollections = (state: RootState) => state.catalogDataSlice.items_collections;

export {
  getCatalogNextTraining,
  getCatalogItems,
  getCatalogItemsCollections
};
